import { Navigate } from 'react-router-dom';
import { usePublisherData } from '../layout/publisherLayout/usePublisherData';
import { Loading } from '@/components/admin';

// Read the last-visited publisher ID. Checks the new key first, then the
// legacy react-admin store key so that returning users on staging aren't
// broken before they've navigated through a publisher route post-deploy.
const getHintPublisherId = (): string | undefined => {
  try {
    return (
      localStorage.getItem('gl:publisher_id') ??
      (JSON.parse(localStorage.getItem('RaStore.publisher_id') ?? 'null') as
        | string
        | null) ??
      undefined
    );
  } catch {
    return undefined;
  }
};

function Dashboard() {
  const hint = getHintPublisherId();

  // Avoid an API call when we already know where to send the user.
  // usePublisherData is still called unconditionally (rules of hooks) but its
  // result is only used when there's no hint.
  const { publishers, isLoading } = usePublisherData();

  if (hint) return <Navigate to={`/publisher/${hint}/offers`} replace />;

  // First-time user: wait for the profile to load and redirect to their first publisher.
  if (isLoading) return <Loading />;

  return <Navigate to={`/publisher/${publishers[0]?.id}/offers`} replace />;
}

export default Dashboard;
